var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        left: "",
        "close-on-content-click": false,
        "max-width": "400",
        "min-width": "320",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "mr-1",
                      attrs: { icon: "", "aria-label": "Notificações" },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c(
                    "v-badge",
                    {
                      attrs: {
                        value: _vm.unreadCount > 0,
                        content: _vm.unreadCount > 99 ? "99+" : _vm.unreadCount,
                        color: "red",
                        overlap: "",
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-bell-outline")])],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menuOpen,
        callback: function ($$v) {
          _vm.menuOpen = $$v
        },
        expression: "menuOpen",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            {
              staticClass:
                "d-flex justify-space-between align-center py-2 px-4",
            },
            [
              _c(
                "span",
                { staticClass: "text-subtitle-1 font-weight-medium" },
                [_vm._v("Notificações")]
              ),
              _vm.unreadCount > 0
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        text: "",
                        "x-small": "",
                        color: "primary",
                        loading: _vm.markingAllRead,
                      },
                      on: { click: _vm.markAllAsRead },
                    },
                    [_vm._v(" Marcar todas como lidas ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("v-divider"),
          _vm.notifications.length > 0
            ? _c(
                "v-list",
                {
                  staticClass: "py-0 notification-list",
                  staticStyle: { "overflow-y": "auto" },
                  attrs: { dense: "", "max-height": "400" },
                },
                [
                  _vm._l(_vm.notifications, function (notification) {
                    return [
                      _c(
                        "v-list-item",
                        {
                          key: notification.id,
                          class: {
                            "unread-notification": !notification.read_at,
                          },
                          attrs: { "three-line": "" },
                          on: {
                            click: function ($event) {
                              return _vm.handleNotificationClick(notification)
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-avatar",
                            { attrs: { size: "40" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: _vm.getNotificationColor(
                                      notification.type
                                    ),
                                    size: "24",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getNotificationIcon(
                                          notification.type
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass: "text-body-2",
                                  class: {
                                    "font-weight-bold": !notification.read_at,
                                  },
                                },
                                [_vm._v(" " + _vm._s(notification.title) + " ")]
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "text-caption" },
                                [
                                  _vm._v(
                                    " " + _vm._s(notification.message) + " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "text-caption grey--text" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatDate(notification.created_at)
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-action",
                            [
                              !notification.read_at
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        "x-small": "",
                                        title: "Marcar como lida",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.markAsRead(notification)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: "primary",
                                          },
                                        },
                                        [_vm._v("mdi-check")]
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        "x-small": "",
                                        color: "grey lighten-1",
                                      },
                                    },
                                    [_vm._v("mdi-check-all")]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  }),
                ],
                2
              )
            : _c(
                "v-card-text",
                { staticClass: "text-center py-8" },
                [
                  _c(
                    "v-icon",
                    { attrs: { size: "48", color: "grey lighten-2" } },
                    [_vm._v("mdi-bell-off-outline")]
                  ),
                  _c("p", { staticClass: "text-body-2 grey--text mt-2 mb-0" }, [
                    _vm._v(" Nenhuma notificação "),
                  ]),
                ],
                1
              ),
          _vm.notifications.length > 0 ? _c("v-divider") : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }